export enum UploadStatusEnum {
  Loading = "LOADING",
  Success = "SUCCESS",
}
